import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  get nativeWindow(): Window {
    return window;
  }
  constructor(private logger: LoggerService) {}

  getIframeEnvironment(): IframeEnvironment {
    const environment = localStorage.getItem('iframeEnvironment');

    if (environment == null) {
      this.setIframeEnviroment();
    }

    this.logger.info('Environment founded on storage: ' + environment);
    return IframeEnvironment[environment as keyof typeof IframeEnvironment];
  }
  // Adicione métodos para manipular o objeto window, se necessário
  setIframeEnviroment(): void {
    let environment;

    switch (window.origin) {
      case 'https://agent-iframe-dev.cloud.itau.com.br':
        environment = IframeEnvironment.Dev;
        break;
      case 'https://agent-iframe-hom.cloud.itau.com.br':
        environment = IframeEnvironment.Hom;
        break;
      case 'https://agent-iframe.cloud.itau.com.br':
        environment = IframeEnvironment.Prod;
        break;
      default:
        environment = IframeEnvironment.Local;
    }

    this.logger.info('environment set on localstorage: ' + environment);
    localStorage.setItem('iframeEnvironment', environment.toString());
  }

  // função para receber um JSON object e tratar as chaves para lowerCase
  keysToLowerCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(this.keysToLowerCase);
    } else if (obj !== null && typeof obj === 'object') {
      const entries = Object.entries(obj).map(([key, value]) => {
        return [key.toLowerCase(), value];
      });
      return Object.fromEntries(entries);
    }
  }

  //função para alterar as aspas simples por duplas e conseguir criar um objeto json valido
  parseJsonAndReplaceQuotes(obj: any): any {
    return JSON.parse(obj.replace(/'/g, '"'));
  }
}

export enum IframeEnvironment {
  Local = 'local',
  Dev = 'dev',
  Hom = 'hom',
  Prod = 'prod',
}
